/* app/js/src/components/clipping-studio/timeline/clipping-studio-timeline-marker/clipping-studio-timeline-marker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: absolute;
  top: 0;
  height: 100%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: auto;
}
.marker-wrapper {
  position: relative;
  height: 100%;
  width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.marker-wrapper.mam-source .marker-line {
  background: rgb(45, 187, 252);
}
.marker-wrapper.mam-source .marker-label {
  width: 8ch;
  min-width: 8ch;
  max-width: 8ch;
  overflow: hidden;
  background: rgb(45, 187, 252);
}
.marker-wrapper.selected .marker-wrapper.mam-source .marker-label {
  background: rgb(41, 170, 229);
}
.marker-wrapper.mam-source .marker-text--readonly {
  color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: 600;
  display: block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marker-hit-area {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 14px;
  transform: translateX(-50%);
  z-index: 0;
  cursor: pointer;
}
.marker-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  transform: translateX(-50%);
  background: rgb(255, 180, 0);
  flex-shrink: 0;
  z-index: 1;
  pointer-events: none;
}
.marker-wrapper.selected .marker-line {
  background: rgb(163, 115, 0);
  box-shadow: 0 0 0 1px rgb(224, 158, 0);
}
.marker-wrapper.mam-source.selected .marker-line {
  background: rgb(41, 170, 229);
  box-shadow: 0 0 0 1px rgb(41, 170, 229);
}
.marker-label {
  position: absolute;
  top: 2px;
  left: 50%;
  margin-left: 2px;
  padding: 2px 6px;
  background: rgb(255, 180, 0);
  border-radius: 0 2px 2px 0;
  white-space: nowrap;
  max-width: 200px;
  z-index: 1;
}
.marker-wrapper.selected .marker-label {
  background: rgb(163, 115, 0);
}
.marker-wrapper.mam-source.selected .marker-label {
  background: rgb(41, 170, 229);
}
.marker-text {
  border: none;
  background: transparent;
  color: rgb(35, 47, 58);
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: 600;
  min-width: 4ch;
  padding: 0;
  outline: none;
  display: block;
  text-align: left;
}
/*# sourceMappingURL=clipping-studio-timeline-marker.component.css.map */
